;(function () {
  'use strict';

  // ============================================
  // 常量定义
  // ============================================
  const BUNDLE_CLASS = 'cart-item--bundle-accessory';
  const MAIN_BUNDLE_CLASS = 'cart-item--bundle-main';
  const HIDE_STYLE_ID = 'bundle-accessory-cart-style';
  const ACCESSORY_ROLE = 'accessory';
  const MAIN_ROLE = 'main';
  const BUNDLE_KEY_ATTR = 'data-bundle-key';
  const BUNDLE_ROLE_ATTR = 'data-bundle-role';
  const BUNDLE_ITEM_KEYS_ATTR = 'data-bundle-item-keys';

  // ============================================
  // 样式注入：隐藏配件的操作按钮
  // ============================================
  function ensureHideStyle() {
    if (document.getElementById(HIDE_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = HIDE_STYLE_ID;
    style.textContent = `
      .${BUNDLE_CLASS} .quantity,
      .${BUNDLE_CLASS} .quantity-selector,
      .${BUNDLE_CLASS} .cart-item__quantity,
      .${BUNDLE_CLASS} .cart-item__quantity-wrapper,
      .${BUNDLE_CLASS} .js-qty,
      .${BUNDLE_CLASS} .quantity__button,
      .${BUNDLE_CLASS} .quantity__input,
      .${BUNDLE_CLASS} .quantity-down,
      .${BUNDLE_CLASS} .quantity-up,
      .${BUNDLE_CLASS} .cart-item__remove,
      .${BUNDLE_CLASS} .cart-remove,
      .${BUNDLE_CLASS} .cart-item__actions,
      .${BUNDLE_CLASS} [data-quantity-button],
      .${BUNDLE_CLASS} [name^="updates_"] {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  // ============================================
  // DOM 辅助函数
  // ============================================
  function getItemContainer(element) {
    return element && element.closest
      ? element.closest('.cart-item, .cart-drawer__item, [data-merge-list-item]')
      : null;
  }

  function getCartItemElements() {
    return Array.from(
      document.querySelectorAll('.cart-item, .cart-drawer__item, [data-merge-list-item]')
    );
  }

  function getCartForms() {
    return Array.from(document.querySelectorAll('cart-form'));
  }

  // 找到指定 item key 的数量 input 元素
  function getQuantityInputByKey(itemKey) {
    const container = findItemContainerByKey(itemKey);
    if (!container) return null;
    // 查找所有 input，包括 hidden 类型
    const inputs = container.querySelectorAll('.cart-item__quantity-input, [name="updates[]"]');
    // 返回第一个可见的 input，或者返回 hidden input
    for (const input of inputs) {
      if (input.type !== 'hidden') return input;
    }
    return inputs[0]; // fallback to hidden
  }

  // ============================================
  // Bundle 元数据解析
  // ============================================
  function parseBundleMeta(container) {
    if (!container) return null;

    // 从 data 属性或从父级 data-merge-list-item 获取
    let bundleKey = container.dataset.bundleKey ||
                     container.getAttribute(BUNDLE_KEY_ATTR) ||
                     '';
    let role = container.dataset.bundleRole ||
               container.getAttribute(BUNDLE_ROLE_ATTR) ||
               '';
    let itemKeysStr = container.dataset.bundleItemKeys ||
                      container.getAttribute(BUNDLE_ITEM_KEYS_ATTR) ||
                      '';

    // 如果当前元素没有完整的 bundle 信息，尝试从父级获取
    if (!bundleKey || !role) {
      const parentMergeItem = container.closest('[data-merge-list-item]');
      if (parentMergeItem) {
        bundleKey = bundleKey || parentMergeItem.dataset.bundleKey || '';
        role = role || parentMergeItem.dataset.bundleRole || '';
        itemKeysStr = itemKeysStr || parentMergeItem.dataset.bundleItemKeys || '';
      }
    }

    const itemKeys = itemKeysStr
      ? itemKeysStr.split(',').map(k => k.trim()).filter(Boolean)
      : [];

    return {
      key: bundleKey,
      role: role,
      itemKeys: itemKeys,
      container: container
    };
  }

  // ============================================
  // 找到指定 item key 对应的 DOM 元素
  // ============================================
  function findItemContainerByKey(itemKey) {
    // 方法1: data-cart-item-key 属性
    const byDataKey = document.querySelector(`[data-cart-item-key="${itemKey}"]`);
    if (byDataKey) return getItemContainer(byDataKey);

    // 方法2: data-merge-list-item 的 data-key
    const allMergeItems = document.querySelectorAll('[data-merge-list-item]');
    for (const item of allMergeItems) {
      if (item.dataset.key === itemKey || item.dataset.cartItemKey === itemKey) {
        return item;
      }
    }

    // 方法3: 在 cart-item 内查找 name="updates[]" data-key
    const allInputs = document.querySelectorAll('[name="updates[]"][data-key]');
    for (const input of allInputs) {
      if (input.dataset.key === itemKey) {
        return getItemContainer(input);
      }
    }

    return null;
  }

  // ============================================
  // 核心功能：设置所有 bundle item 的数量
  // ============================================

  /**
   * 设置同 bundle 下所有 item 的数量
   * 这是关键：CartForm.adjustItemQuantity 会读取所有 input 的值来生成 updates
   */
  function setBundleItemQuantities(itemKeys, quantity) {
    itemKeys.forEach(key => {
      const container = findItemContainerByKey(key);
      if (!container) {
        console.warn('[bundle-cart] Cannot find container for key:', key);
        return;
      }

      const input = container.querySelector('.cart-item__quantity-input, [name="updates[]"]');
      if (input) {
        input.value = quantity;
        // 标记需要刷新
        const mergeItem = container.closest('[data-merge-list-item]') || container;
        if (mergeItem.classList) {
          mergeItem.classList.add('merge-item-refreshing');
        }
      }
    });
  }

  /**
   * 获取指定 item key 的数量 input 元素
   */
  function getQuantityInputByKey(itemKey) {
    const container = findItemContainerByKey(itemKey);
    if (!container) return null;
    return container.querySelector('.cart-item__quantity-input, [name="updates[]"]');
  }

  // ============================================
  // 删除按钮处理
  // ============================================
  function isRemoveButton(element) {
    if (!element) return false;

    const candidate = element.closest ? element.closest('a, button') : element;
    if (!candidate) return false;

    const href = (candidate.getAttribute('href') || '').toLowerCase();
    const name = (candidate.getAttribute('name') || '').toLowerCase();
    const classes = (candidate.className || '').toLowerCase();
    const text = (candidate.textContent || '').trim().toLowerCase();
    const aria = (candidate.getAttribute('aria-label') || '').toLowerCase();

    // 精确匹配删除：必须是 quantity=0 且是 /cart/change URL
    const isDeleteUrl = href.includes('/cart/change') && href.includes('quantity=0');

    // 或者明确标记的删除按钮
    const isExplicitRemove =
      name.includes('remove') ||
      classes.includes('remove') ||
      classes.includes('cart-item__remove') ||
      text === 'remove' ||
      aria.includes('remove');

    return isDeleteUrl || isExplicitRemove;
  }

  /**
   * 触发 CartForm 的数量更新
   * 关键：在调用 CartForm 方法前，先手动构建 updates 对象
   */
  function triggerCartFormUpdate(container, itemKeys, quantity) {
    // 找到最近的 cart-form
    const cartForm = container.closest('cart-form');

    // 方法1: 如果有 CartForm，获取它内部的 updates 数据
    if (cartForm) {
      // 设置所有 bundle item 的数量
      itemKeys.forEach(key => {
        const c = findItemContainerByKey(key);
        if (c) {
          const inputs = c.querySelectorAll('[name="updates[]"]');
          inputs.forEach(inp => {
            inp.value = quantity;
          });
        }
      });

      // 如果 CartForm 有 adjustItemQuantity，调用它
      if (typeof cartForm.adjustItemQuantity === 'function') {
        cartForm.adjustItemQuantity(container, { to: quantity });
        return true;
      }

      // 如果 CartForm 有 submit 方法，手动提交
      if (typeof cartForm.submit === 'function') {
        cartForm.submit();
        return true;
      }
    }

    // 方法2: 手动构建更新数据并触发更新
    // 通过页面表单提交的方式
    const form = document.querySelector('form[action*="/cart"]');
    if (form) {
      // 确保所有 bundle item 的 input 都已设置
      itemKeys.forEach(key => {
        const c = findItemContainerByKey(key);
        if (c) {
          const inputs = c.querySelectorAll('[name="updates[]"]');
          inputs.forEach(inp => {
            inp.value = quantity;
          });
        }
      });

      // 提交表单
      form.submit();
      return true;
    }

    // 方法3: 降级到 fetch（可能触发人机验证）
    return false;
  }

  /**
   * 手动发送批量更新请求
   * 当无法通过 CartForm 方法处理时使用
   */
  function sendCartUpdateRequest(itemKeys, quantity) {
    const updates = {};
    itemKeys.forEach(key => {
      updates[key] = quantity;
    });

    // 获取 cart update URL
    const updateUrl = window.Shopify?.routes?.cartUpdate || '/cart/update.js';

    fetch(updateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(response => {
        if (!response.ok) throw new Error('Update failed');
        return response.json();
      })
      .then(cart => {
        // 触发购物车刷新事件
        document.dispatchEvent(new CustomEvent('on:cart:change', {
          bubbles: true,
          cancelable: false
        }));
      })
      .catch(error => {
        console.error('[bundle-cart] Update failed:', error);
        // 降级：刷新页面
        window.location.reload();
      });
  }

  // ============================================
  // Loading 状态管理
  // ============================================
  const LOADING_CLASS = 'bundle-cart-loading';

  function addLoadingStyle() {
    if (document.getElementById('bundle-cart-loading-style')) return;
    const style = document.createElement('style');
    style.id = 'bundle-cart-loading-style';
    style.textContent = `
      .${LOADING_CLASS} {
        position: relative;
        opacity: 0.6;
        pointer-events: none;
      }
      .${LOADING_CLASS}::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin: -10px 0 0 -10px;
        border: 2px solid rgba(0,0,0,0.1);
        border-top-color: #000;
        border-radius: 50%;
        animation: bundle-cart-spin 0.6s linear infinite;
      }
      @keyframes bundle-cart-spin {
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  function showLoading(container) {
    if (!container) return;
    addLoadingStyle();
    // 给整个 bundle 组添加 loading
    const mergeItem = container.closest('[data-merge-list-item]') || container;
    mergeItem.classList.add(LOADING_CLASS);

    // 超时自动移除（10秒后还没响应就移除）
    setTimeout(() => {
      hideLoading(container);
    }, 10000);
  }

  function hideLoading(container) {
    if (!container) return;
    const mergeItem = container.closest('[data-merge-list-item]') || container;
    mergeItem.classList.remove(LOADING_CLASS);
  }

  // 监听购物车更新完成事件
  function setupLoadingCleanup() {
    // 通用刷新事件
    document.addEventListener('on:cart:change', () => {
      setTimeout(() => {
        document.querySelectorAll('.' + LOADING_CLASS).forEach(el => {
          el.classList.remove(LOADING_CLASS);
        });
      }, 100);
    });

    // 页面卸载 loading
    window.addEventListener('beforeunload', () => {
      document.querySelectorAll('.' + LOADING_CLASS).forEach(el => {
        el.classList.remove(LOADING_CLASS);
      });
    });

    // fetch 请求完成
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0] instanceof Request ? args[0].url : args[0];
      if (typeof url === 'string' && url.includes('/cart')) {
        return originalFetch.apply(this, args).finally(() => {
          setTimeout(() => {
            document.querySelectorAll('.' + LOADING_CLASS).forEach(el => {
              el.classList.remove(LOADING_CLASS);
            });
          }, 300);
        });
      }
      return originalFetch.apply(this, args);
    };
  }

  // ============================================
  // 3D 预览图替换
  // ============================================
  
  /**
   * 根据 bundle key 清理对应的预览图
   */
  function cleanupBundlePreviewImages(bundleKey) {
    if (!bundleKey) return;
    
    console.log('[bundle-cart] Cleaning up preview images for bundle:', bundleKey);
    
    // 遍历所有 bundle_preview_ 开头的 localStorage 项
    const keysToRemove = [];
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('bundle_preview_') && key.includes(bundleKey)) {
        keysToRemove.push(key);
      }
    });
    
    // 删除匹配的键
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
      console.log('[bundle-cart] ✓ Removed preview:', key);
    });
    
    if (keysToRemove.length === 0) {
      console.log('[bundle-cart] No preview images to clean up');
    }
  }
  
  /**
   * 清理页面中所有已不存在的 bundle 预览图
   * （当购物车刷新后调用）
   */
  function cleanupOrphanedPreviewImages() {
    const previewLinks = document.querySelectorAll('a[data-preview-key]');
    const activeKeys = new Set();
    
    // 收集当前页面所有有效的 preview key
    previewLinks.forEach(link => {
      const key = link.dataset.previewKey;
      if (key) {
        activeKeys.add('bundle_preview_' + key);
      }
    });
    
    // 清理不在页面上的预览图
    let removed = 0;
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('bundle_preview_') && !activeKeys.has(key)) {
        localStorage.removeItem(key);
        removed++;
      }
    });
    
    if (removed > 0) {
      console.log('[bundle-cart] ✓ Cleaned up', removed, 'orphaned preview images');
    }
  }
  
  function apply3DPreviewImages() {
    // 查找所有有 preview-key 的图片链接
    const previewLinks = document.querySelectorAll('a[data-preview-key]');
    
    console.log('[bundle-cart] apply3DPreviewImages called, found links:', previewLinks.length);
    
    previewLinks.forEach(link => {
      const previewKey = link.dataset.previewKey;
      console.log('[bundle-cart] Processing preview key:', previewKey);
      
      if (!previewKey) {
        console.log('[bundle-cart] No preview key found on link');
        return;
      }
      
      // 从 localStorage 获取预览图
      const storageKey = 'bundle_preview_' + previewKey;
      const previewDataUrl = localStorage.getItem(storageKey);
      
      console.log('[bundle-cart] Storage key:', storageKey);
      console.log('[bundle-cart] Found preview data:', !!previewDataUrl, previewDataUrl ? '(' + previewDataUrl.length + ' chars)' : '');
      
      if (previewDataUrl) {
        // 找到图片并替换
        const img = link.querySelector('img');
        if (img) {
          // 检查当前图片 URL
          console.log('[bundle-cart] Original img src:', img.src ? (img.src.length > 50 ? img.src.substring(0, 50) + '...' : img.src) : 'empty');
          
          // 创建新图片预加载，确保加载完成后再替换
          const tempImg = new Image();
          tempImg.onload = function() {
            // 替换图片 src
            img.src = previewDataUrl;
            
            // 强制移除 lazy loading 相关属性
            img.removeAttribute('loading');
            img.removeAttribute('data-src');
            img.removeAttribute('data-widths');
            img.removeAttribute('data-sizes');
            img.removeAttribute('srcset');
            img.classList.remove('lazyload', 'lazyloaded');
            img.classList.add('lazypreload'); // 标记为已预加载
            
            // 强制触发重绘
            img.style.display = 'none';
            img.offsetHeight; // 触发 reflow
            img.style.display = '';
            
            // 查找并替换可能的 srcset 图片
            const pictureElement = link.querySelector('picture');
            if (pictureElement) {
              const sources = pictureElement.querySelectorAll('source');
              sources.forEach(source => {
                source.removeAttribute('srcset');
                source.removeAttribute('data-srcset');
              });
            }
            
            console.log('[bundle-cart] ✓ Applied 3D preview image for:', previewKey);
            console.log('[bundle-cart] New img src:', img.src.substring(0, 50) + '...');
          };
          tempImg.onerror = function() {
            console.log('[bundle-cart] ✗ Failed to preload preview image');
          };
          tempImg.src = previewDataUrl;
        } else {
          console.log('[bundle-cart] ✗ No img found inside link');
          // 调试：打印 link 的 HTML
          console.log('[bundle-cart] Link innerHTML:', link.innerHTML.substring(0, 200));
        }
      } else {
        console.log('[bundle-cart] ✗ No preview image in localStorage for key:', storageKey);
        // 列出 localStorage 中所有 bundle_preview_ 开头的 key
        const allKeys = Object.keys(localStorage).filter(k => k.startsWith('bundle_preview_'));
        console.log('[bundle-cart] Available preview keys in localStorage:', allKeys);
      }
    });
  }

  // 监听购物车加载完成后应用预览图
  function setupPreviewImageReplacement() {
    // 页面加载时
    setTimeout(apply3DPreviewImages, 500);
    
    // 购物车 AJAX 刷新后
    document.addEventListener('on:cart:change', () => {
      setTimeout(apply3DPreviewImages, 300);
    });
    document.addEventListener('on:cart:after-merge', () => {
      setTimeout(apply3DPreviewImages, 300);
    });
  }

  // ============================================
  // 事件处理
  // ============================================

  /**
   * 判断是否是数量增减按钮
   */
  function isQuantityButton(element) {
    if (!element) return false;
    const candidate = element.closest ? element.closest('a, button') : element;
    if (!candidate) return false;

    const classes = (candidate.className || '').toLowerCase();
    return (
      classes.includes('quantity-up') ||
      classes.includes('quantity-down') ||
      classes.includes('quantity__button') ||
      classes.includes('js-qty__adjust')
    );
  }

  /**
   * 计算数量按钮点击后的新数量
   */
  function getNewQuantityFromButton(button, currentQuantity) {
    const classes = (button.className || '').toLowerCase();
    // 判断是否是增减按钮（quantity-up, quantity-down, quantity__button, js-qty__adjust）
    const isQuantityBtn = classes.includes('quantity-up') ||
                          classes.includes('quantity-down') ||
                          classes.includes('quantity__button') ||
                          classes.includes('js-qty__adjust');
    if (!isQuantityBtn) return currentQuantity;

    // 判断是加还是减
    // 1. 通过 class 判断
    if (classes.includes('quantity-up')) {
      return currentQuantity + 1;
    }
    if (classes.includes('quantity-down')) {
      return Math.max(0, currentQuantity - 1);
    }

    // 2. 通过 id 判断
    const id = (button.id || '').toLowerCase();
    if (id.includes('inc') || id.includes('_up')) {
      return currentQuantity + 1;
    }
    if (id.includes('dec') || id.includes('_down')) {
      return Math.max(0, currentQuantity - 1);
    }

    // 3. 通过 aria-label 或 text 判断
    const aria = (button.getAttribute('aria-label') || '').toLowerCase();
    const text = (button.textContent || '').toLowerCase();
    if (aria.includes('increase') || aria.includes('增加') || text.includes('+')) {
      return currentQuantity + 1;
    }
    if (aria.includes('decrease') || aria.includes('减少') || text.includes('-')) {
      return Math.max(0, currentQuantity - 1);
    }

    // 默认：认为是减按钮
    return Math.max(0, currentQuantity - 1);
  }

  /**
   * 点击事件处理
   */
  function handleClick(event) {
    const container = getItemContainer(event.target);
    if (!container) return;

    const meta = parseBundleMeta(container);
    if (!meta || !meta.key || meta.itemKeys.length < 2) {
      return; // 不是 bundle
    }

    // 检查是否是删除按钮
    if (isRemoveButton(event.target)) {
      if (meta.role !== MAIN_ROLE) return; // 配件删除按钮已隐藏

      event.preventDefault();
      event.stopPropagation();

      // 显示 loading
      showLoading(container);

      // 清理该 bundle 的预览图
      cleanupBundlePreviewImages(meta.key);

      const handled = triggerCartFormUpdate(container, meta.itemKeys, 0);
      if (!handled) {
        sendCartUpdateRequest(meta.itemKeys, 0);
      }
      return;
    }

    // 检查是否是数量增减按钮
    if (isQuantityButton(event.target)) {
      if (meta.role !== MAIN_ROLE) return; // 只处理主商品的按钮

      const input = container.querySelector('.cart-item__quantity-input:not([type="hidden"])');
      if (!input) return;

      const currentQuantity = parseInt(input.value) || 0;
      const newQuantity = getNewQuantityFromButton(event.target, currentQuantity);

      if (newQuantity === currentQuantity) return;

      event.preventDefault();
      event.stopPropagation();

      // 显示 loading
      showLoading(container);

      // 设置主商品的新数量
      input.value = newQuantity;

      // 同步所有配件的数量
      meta.itemKeys.forEach(key => {
        const c = findItemContainerByKey(key);
        if (!c) return;
        const role = c.dataset.bundleRole || c.getAttribute(BUNDLE_ROLE_ATTR) || '';
        if (role === ACCESSORY_ROLE) {
          const inputs = c.querySelectorAll('[name="updates[]"]');
          inputs.forEach(inp => {
            inp.value = newQuantity;
          });
        }
      });

      // 触发 CartForm 更新
      const handled = triggerCartFormUpdate(container, meta.itemKeys, newQuantity);
      if (!handled) {
        sendCartUpdateRequest(meta.itemKeys, newQuantity);
      }
    }
  }

  // ============================================
  // Bundle 标记（从旧版本保留）
  // ============================================
  function markBundleItems() {
    const elements = getCartItemElements();
    elements.forEach(element => {
      const meta = parseBundleMeta(element);

      if (meta && meta.role === ACCESSORY_ROLE) {
        element.classList.add(BUNDLE_CLASS);
        element.classList.remove(MAIN_BUNDLE_CLASS);
      } else if (meta && meta.role === MAIN_ROLE) {
        element.classList.add(MAIN_BUNDLE_CLASS);
        element.classList.remove(BUNDLE_CLASS);
      } else {
        element.classList.remove(BUNDLE_CLASS, MAIN_BUNDLE_CLASS);
      }
    });
  }

  // ============================================
  // 初始化
  // ============================================
  function init() {
    ensureHideStyle();
    markBundleItems();
    setupLoadingCleanup();
    setupPreviewImageReplacement();

    // 监听点击事件（包含删除和数量按钮）
    document.addEventListener('click', handleClick, true);

    // 购物车刷新后重新标记
    document.addEventListener('on:cart:change', () => {
      setTimeout(markBundleItems, 100);
    });
    document.addEventListener('on:cart:after-merge', () => {
      setTimeout(markBundleItems, 100);
    });

    console.log('[bundle-cart] Initialized - Form-based AJAX mode');
  }

  // DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
